import { Breadcrumb, Col, Row } from "antd";
import ResetButton from "../UI/ResetButton/resetbutton";
import { ChangeEvent, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useParams } from "react-router-dom";
import InventoryDetailsList from "./inventoryDetailsList";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { Search } from "../UI/Search/Search";
import { useMutation } from "react-query";
import { getInventoriesDetailsApi } from "../../api/inventorysummary";

function InventoryDetails() {
  const [paginatedInventoriesDetails, setPaginatedInventoriesDetails] =
    useState<string>();
  const { id } = useParams();
  const [search, setSearch] = useState<string>("");

  const [tableKey, setTableKey] = useState(1000);
  const { t } = useTranslation("common");

  const resetFilters = () => {
    setSearch("");
    setTableKey((tableKey) => tableKey + 1);
    InventoriesDetailsMutation({ id, search: "" });
  };

  const {
    mutateAsync: InventoriesDetailsMutation,
    isLoading: isInventoriesDetailsLoading,
  } = useMutation(
    "InventoriesDetails",
    ({ id, search }: { id: number | string | undefined; search: string }) =>
      getInventoriesDetailsApi(id, search),
    {
      onSuccess: (res) => {
        setPaginatedInventoriesDetails(res.data);
      },
    }
  );

  const location = useLocation();
  const category = location?.state?.q;

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={20}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: <>{t("inventory-summary")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor">
                    {t("inventory-summary")}
                  </span>
                ),
              },
            ]}
          />
        </Col>
        <Col
          offset={1}
          span={22}
          style={{ fontSize: "32px", color: "#162149", fontWeight: "600px" }}>
          {category}
        </Col>
        <Col offset={1} span={4}>
          <Search
            value={search}
            onChange={(e:any) => {
              setSearch(e.target.value);
            }}
            onEnter={() => InventoriesDetailsMutation({ id, search })}
          />
        </Col>
        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}>
          <ResetButton
            onClick={() => {
              resetFilters();
                  // setPaginatedInventoriesDetails(res.data);
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <InventoryDetailsList
            isInventoriesDetailsLoading={isInventoriesDetailsLoading}
            paginatedInventoriesDetails={paginatedInventoriesDetails}
            InventoriesDetailsMutation={InventoriesDetailsMutation}
            setPaginatedInventoriesDetails={setPaginatedInventoriesDetails}
            search={search}
            id={id}
            tableKey={tableKey}
          />
        </Col>
      </Row>

      <Col
        offset={1}
        style={{
          marginTop: "15%",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}>
        <CancelBtn />
      </Col>
    </>
  );
}

export default InventoryDetails;
